import axios from "axios";
import { environment } from "../../environment";
import {
  ContentItem,
  MediaFile,
  SefariaLink,
  HartmanLink,
  ExternalLink,
  SessionRecording,
  MediaItem,
} from "hc-entities";
import { createFormData } from "../helpers/helpers";
import moment from "moment";
import { ContentMap } from "../helpers/consts";
import { AdminContentItem } from "../../store/reducers/contentReducer";

export const ContentService = () => {

  const toAdminContentItem = (data: any[]): AdminContentItem[] => {
    const contentItems: AdminContentItem[] = [];
    data.map((c: any, i: number) => {
      contentItems.push({
        related: c.related ? c.related.map((r: any) => ({ label: r.title, value: r._id })) : [],
        m_id: c.modifiedBy ? c.modifiedBy._id : "",
        c_id: c.createdBy ? c.createdBy._id : "",
        m_name: c.modifiedBy
          ? c.modifiedBy.firstName + " " + c.modifiedBy.lastName
          : "",
        c_name: c.createdBy
          ? c.createdBy.firstName + " " + c.createdBy.lastName
          : "",
        u_name: c.uploadedBy
          ? c.uploadedBy.firstName + " " + c.uploadedBy.lastName
          : "",
        modified_by: c.modifiedBy ? c.modifiedBy : "",
        created_by: c.createdBy ? c.createdBy : "",
        uploaded_by: c.uploadedBy ? c.uploadedBy : "",
        modified: c.modified
          ? moment(new Date(parseInt(c.modified))).calendar()
          : c.modified,
        created: c.created
          ? moment(new Date(parseInt(c.created))).calendar()
          : c.created,
        created_on: c.createdOn ? c.createdOn : "",
        id: data.length - i,
        content_id: c._id,
        title: c.title,
        type: c.media ? c.media[0].type : "",
        description: c.description,
        publish_amount: c.publishAmount ? c.publishAmount : 0,
        community: c.community,
        show_item_in_search: c.showInSearch ? c.showInSearch : false,
        tags: c.tags,
        status: c.status ? c.status : "",
        who_can_see: c.whoCanSee ? c.whoCanSee : 0,
        division: c.division ? c.division : "",
        file:
          c.media[0].type === "file"
            ? c.media[0].azureLink
            : undefined,
        link:
          c.media[0].type !== "file"
            ? (c.media[0] as SefariaLink).link
            : undefined,

        thumbnail: c.thumbnail,
        file_type: c.fileType
      });
      return c;
    });
    return contentItems;
  }

  const getOgData = async (url: string) => {
    try {
      let path, res, og;
      //path = `${environment.contentUrl}getog/${encodeURIComponent(url)}`;
      // res = await axios.get(path);

      path = `${environment.contentUrl}postOG`;
      const data = {
        url: url
      }
      res = await axios.post(path, data, {
        headers: {
          "Content-Type": "application/json"
        },
      });

      // path = `https://api.linkpreview.net/?key=${environment.linkpreview}&q=${url}`;
      // res = await axios.get(path);
      if (res?.data) {
        og = res.data;
      }
      return {
        title: og?.title,
        thumbnail: og?.ogImage,
        description: og?.description,
        tags: [],
      };
    } catch (err) {
      throw err;
    }
  };

  const getWpData = async (url: string) => {
    try {
      const path = environment.contentUrl + "hartmanLink?url=" + url;
      const res = await axios.get(path);
      if (res?.data) return res.data;
      else return undefined;
    } catch (err) {
      throw err;
    }
  };

  const getMediaItem = (content: AdminContentItem): MediaItem => {
    try {
      switch (content.type) {
        case ContentMap[0]: {
          return new MediaFile({
            type: content.type,
            file: content.file,
          });
        }
        case ContentMap[1]: {
          return new SefariaLink({
            type: content.type,
            link: content.link,
          });
        }
        case ContentMap[2]: {
          return new HartmanLink({
            type: content.type,
            link: content.link,
          });
        }
        case ContentMap[3]: {
          return new ExternalLink({
            type: content.type,
            link: content.link,
          });
        }
        case ContentMap[4]: {
          return new SessionRecording({
            type: content.type,
            link: content.link,
          });
        }
        default:
          throw new Error("No link");
      }
    } catch (err) {
      throw err;
    }
  };

  const post = async (content: AdminContentItem) => {

    try {
      const _content = new ContentItem({
        title: content.title,
        type: content.type,
        publishAmount: content.publish_amount,
        createdBy: content.created_by,
        uploadedBy: content.uploaded_by,
        showInSearch: content.show_item_in_search,
        whoCanSee: content.who_can_see,
        community: content.community,
        thumbnail: content.thumbnail,
        description: content.description,
        fileType: content.file_type,
        tags: content.tags,
        createdOn: content.created_on,
        media: [getMediaItem(content)],
        related: content.related ? content.related.map(r => r.value) : [],
        division: content.division,
        status: content.status,
      });

      if (content.content_id) {
        _content.modifiedBy = content.modified_by;
        _content._id = content.content_id;
      }

      const formData = createFormData(_content, new FormData());
      const path = environment.contentUrl + "new";
      const res = await axios.post(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (err) {
      throw err;
    }
  };

  const get = async () => {
    try {
      const res = await axios.get(environment.contentUrl + "items");
      if (res && res.data) {
        return toAdminContentItem(res.data);
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  const getAdminContentItems = async (userid: any) => {
    try {
      const res = await axios.get(environment.contentUrl + "adminContentItems/" + userid);
      if (res && res.data) {
        return toAdminContentItem(res.data);
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  const getTags = async () => {
    try {
      const res = await axios.get(environment.contentUrl + "tags");
      if (res) {
        return res.data;
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };


  const getContentItemsCreators = async () => {
    try {
      const res = await axios.get(environment.contentUrl + "users/admin/");
      if (res) {
        return res.data;
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  const filterAdminContentItems = async (term: string, type: string) => {
    try {
      console.log({ term }, { type });
      const res = await axios.get(environment.contentUrl + "adminFilterContentItems/", {
        params: {
          term, type
        }
      });

      if (res && res.data) {
        return toAdminContentItem(res.data);
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  const searchContentItems = async (term: String) => {
    try {
      const res = await axios.get(environment.contentUrl + "items/search/" + term);
      if (res && res.data) {
        return toAdminContentItem(res.data);
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  }

  const getContentItemById = async (contentId: string) => {
    try {
      const res = await axios.get(environment.contentUrl + "adminContentItem/" + contentId);
      if (res && res.data) {
        return toAdminContentItem(res.data);
      } else {
        throw new Error("No CI was found");
      }
    } catch (err) {
      throw err;
    }
  };


  return {
    searchContentItems,
    getOgData,
    getWpData,
    post,
    get,
    getAdminContentItems,
    filterAdminContentItems,
    getTags,
    getContentItemsCreators,
    getContentItemById,
  };
};


// DEPRECATED FUNCTIONS
// const wpQuery = async (baseurl: any, which: string, what: string) => {
//   try {
//     let path, wpData;
//     switch (which) {
//       case 'post':
//         if (typeof what === 'number') {
//           path = `${baseurl}wp-json/wp/v2/posts/${what}`;
//           wpData = await axios.get(path);
//         } else {
//           path = `${baseurl}wp-json/wp/v2/posts?&per_page=1&search=${what}`;
//           wpData = await axios.get(path);
//           wpData.data = wpData.data[0];
//         }
//         break;
//       case 'tag':
//         path = `${baseurl}wp-json/wp/v2/tags/${what}`;
//         wpData = await axios.get(path);
//         break;
//       case 'media':
//         path = `${baseurl}wp-json/wp/v2/media/${what}`;
//         wpData = await axios.get(path);
//         break;
//       default:
//         break;
//     }
//     return wpData && wpData.data ? wpData.data : undefined;
//   } catch (err) {
//     throw err;
//   }
// }

// const getWpData = async (url: string) => {
//   try {
//     let tags, thumbnail, title, description, _baseurl : any;
//     switch (url) {
//       case 'https://heb.hartman.org.il/':
//         _baseurl = 'https://heb.hartman.org.il/';
//         break;
//       case 'https://hartman.org.il/':
//         _baseurl = 'https://hartman.org.il/';
//         break;
//       case 'https://dev.hartman.org.il/':
//         _baseurl = 'https://dev.hartman.org.il/';
//         break;
//       default:
//         _baseurl = 'https://hartman.org.il/';
//         break;
//     }

//     const what =
//       url.split('/').length === 5
//         ? url.split('/')[3].split('-').join(' ')
//         : '';

//     const post = await wpQuery(_baseurl, 'post', what);

//     if (post) {
//       title = post.title?.rendered ? post.title.rendered : '';
//       description = title;
//       tags = post.tags
//         ? await Promise.all(
//           post?.tags?.map(async (t: any) => {
//             const res = await wpQuery(_baseurl , 'tag', t);
//             return res?.name ? res?.name : '';
//           }),
//         )
//         : [];
//       thumbnail = post.featured_media
//         ? await wpQuery(_baseurl, 'media', post.featured_media)
//         : '';
//       thumbnail = thumbnail?.mime_type?.includes('image/')
//         ? thumbnail?.source_url
//         : '';
//     }
//     return post
//       ? {
//         title,
//         description,
//         tags,
//         thumbnail,
//       }
//       : undefined;
//   } catch (err) {
//     throw err;
//   }
// }